import React, { useContext, useEffect, useState } from "react";
import { Checkout } from '../../styles/Layout.css'
import { PageAlwaysVisible, PageTitle, AlertContext, Alert_, ThemeContext, Single_, Form, device, PageFull, Grey_, } from 'monica-alexandria'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Summary_ from './components/Summary_';
import Payment_Details from './components/Payment_Details'
import CRM_Checkout from "./components/CRM_Checkout";

import store from "../../redux/store";
import i18n from "../../localization/i18next";
import { Elements } from "@stripe/react-stripe-js";
import { calculate_tax_manual, get_customer } from "../../services/api/Subscriptions";
import { CartContext } from "../../context/CartContext";
import { loadStripe } from "@stripe/stripe-js";
import { Helmet } from "react-helmet";
import { getProductswithCategoryAsInput, retrieve_crm_price_with_vat_excluded } from "../../services/api/Plans";


const OnePageCheckout = styled(PageFull)`

`
const CheckoutGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    grid-gap: 4rem;
    align-items: flex-start;

    @media ${device.xl} {
      grid-template-columns: 1fr;
    }
`

const CheckoutPaymentDetails = styled(Form)`
  border-radius:var(--smallRadius);

`;
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_TEST);

export default function CRM_CHECKOUT() {

    const { alerts, setAlerts } = useContext(AlertContext);
    const { cart = [], setCart } = useContext(CartContext);
    const { t } = useTranslation();
    const lang = i18n.language ? i18n.language : "el";
    const { theme } = useContext(ThemeContext);
    const [tax, setTax] = useState(false);
    const [taxInputKey, setTaxInputKey] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isProductLoading, setIsProductLoading] = useState(true)
    const [isCartLoading, setIsCartLoading] = useState(true)
    const [customerIsLoading, setCustomerIsLoading] = useState(true);

    const user = store.getState().user.user;
    const currentCart = cart.filter(item => item?.category === 'crm');
    const coupon = window?.sessionStorage?.getItem('coupon')
    const trial = window?.sessionStorage?.getItem('trial')
    const [customer, setCustomer] = useState(false);

    const [checkoutError, setCheckoutError] = useState('');
    const [requestVersion, setRequestVersion] = useState(0);
  
    const [billingFields, setBillingFields] = useState({});
    const [selectedCountry, setSelectedCountry] = useState('GR');
    const [selectedAmount, setSelectedAmount] = useState(false);
    const [showVatInput, setShowVatInput] = useState(true);

    const taxKey = JSON.stringify([selectedCountry, selectedAmount, coupon, Boolean(showVatInput)]);
    const taxReady = Boolean(tax && taxInputKey === taxKey);

    const check_if_customer_exists = () => {
      get_customer(user?.sub, 'crm')
        .then(res => {
          if (!res?.customer || typeof res.customer !== 'object' || Array.isArray(res.customer)) throw new Error('CRM customer lookup unavailable');

          const billingData = {
            name: res?.customer?.name|| `${user?.firstname} ${user?.lastname}`,
            email: res?.customer?.email || user?.username,
            phone: res?.customer?.phone || '',
            address : res?.customer?.address || {}
          };
          setSelectedCountry(res?.customer?.address?.country || 'GR')
          console.log('CUSTOMER', res)
          if(res?.customer?.customerId) setCustomer(res?.customer?.customerId)

          setBillingFields(billingData);

          setCustomerIsLoading(false);
        })
        .catch(() => setCheckoutError('Could not load CRM checkout. Please try again.'))
        .finally(() => setCustomerIsLoading(false));
    }
  
  const initializeCartAndDefaultItem = async products => {
    const matchingPlans = Array.isArray(products) ? products.filter(item =>
      item?.category === 'crm' && item.active === true && item.type === 'recurring' &&
      item.interval === 'day' && item.interval_count === 30
    ) : [];
    if (matchingPlans.length !== 1 || !matchingPlans[0].priceId) throw new Error('CRM product unavailable');
    const product = matchingPlans[0];
    const price = await retrieve_crm_price_with_vat_excluded();
    if (price?.priceId !== product.priceId || price.amount !== product.amount ||
        !Number.isSafeInteger(price.amount) || price.amount <= 0) throw new Error('CRM price unavailable');
    const item = { ...product, amount: price.amount };
    delete item.priceId;
    sessionStorage.removeItem('cart');
    setCart([item]);
    setSelectedAmount(price.amount);
    setIsProductLoading(false);
    setIsCartLoading(false);
  };

  useEffect(() => {
    // A CRM subscription has no advertising quest or inherited advertising cart.
    const query = { category: 'crm', interval: 'day', interval_count: 30 };
    setCheckoutError('');setIsProductLoading(true);setIsCartLoading(true);setIsLoading(true);
    setSelectedAmount(false);setTax(false);setCart([]);
    store.dispatch({ type: 'SAVE_CART_PARAMS', payload: query });
    getProductswithCategoryAsInput(query)
      .then(initializeCartAndDefaultItem)
      .catch(() => setCheckoutError('Could not load CRM checkout. Please try again.'));
  }, [requestVersion]);

  useEffect(() => {
    store.dispatch({ type: 'SAVE_CART', payload: cart.filter(item => item?.category === 'crm') });
  }, [cart]);

    const handleStripeTheme = () => {
        let stripeTheme = theme == "dark" ? "night" : "stripe";
        return stripeTheme;
    }
    ;
    const options = {
        mode: "subscription",
        amount: tax?.totalAmount,
        currency: tax?.currency || 'eur',
        // automatic_payment_methods: {enabled: true},
        paymentMethodCreation: 'manual',
        locale: lang || 'el',
        appearance: {
          theme: handleStripeTheme(),
          labels: "floating",
          variables: {
            fontSizeBase: "1.6",
            spacingUnit: "4",
            borderRadius: "1rem",
          },
        },
      };
      
      useEffect(() => {
      if (!selectedAmount || !selectedCountry) return;
      let active = true;
      setIsLoading(true);
      calculate_tax_manual(selectedCountry, coupon?.couponId, selectedAmount, showVatInput)
        .then(res => {
          if (!active) return;
          if (!Number.isSafeInteger(res?.taxCalculation?.totalAmount) || res.taxCalculation.totalAmount <= 0) throw new Error('CRM total unavailable');
          setTax(res.taxCalculation);
          setTaxInputKey(taxKey);
        })
        .catch(() => { if (active) setCheckoutError('Could not load CRM checkout. Please try again.'); })
        .finally(() => { if (active) setIsLoading(false); });
      return () => { active = false; };
    }, [selectedAmount, coupon, selectedCountry, showVatInput, taxKey]);

    useEffect(() => {
        setCustomerIsLoading(true);
        check_if_customer_exists();
    }, [requestVersion]);
    

      console.log('tax', tax)
      console.log('amount', selectedAmount)

      console.log('cart', cart)
      console.log("country", selectedCountry)

    if (checkoutError) return <PageAlwaysVisible>
      <PageTitle><h1>CRM</h1></PageTitle>
      <p role="alert">{t(checkoutError)}</p>
      <Grey_ text={t('Retry')} onClick={() => setRequestVersion(value => value + 1)} />
    </PageAlwaysVisible>;

    if((isLoading && !tax) || customerIsLoading || isProductLoading || isCartLoading){ return(
        <Single_
         backgroundImage="https://genius1071.friktoriaservers.net/doitforme/morning/app/griphook/ToStripe.svg"
         title={t("Checkout")}
         subtitle={t("Redirecting you to Stripe")}
         text={t("Hold on tight, while we teleport you to the magical land of Stripe where payments are as smooth as butter and the unicorns roam free!")}
       />
    );
    } 
    else return (
      <OnePageCheckout>
        <Helmet>
          <title>Doitforme | CRM subscribe</title>
        </Helmet>
        <Alert_ messages={alerts} duration={5000}/>
        <PageAlwaysVisible>
          <PageTitle>
              <h1>{t("Checkout")}</h1>
          </PageTitle>
          <CheckoutGrid>
            <CRM_Checkout />
            <Summary_ 
              amount ={currentCart?.length ? currentCart[0]?.amount : ""} 
              tax={taxReady ? tax.taxAmount : ""}
              total={taxReady ? tax.totalAmount : ""}
              currency={tax?.currency || "eur"}
            />
            {options?
              <CheckoutPaymentDetails>
                <Elements stripe={stripePromise} options={options}>
                  <h3>{t("Billing information")}</h3>
                  <Payment_Details 
                    showVatInput={showVatInput} 
                    setShowVatInput={setShowVatInput} 
                    customer={customer} 
                    setCustomer={setCustomer} 
                    selectedCountry={selectedCountry} 
                    setSelectedCountry={setSelectedCountry} 
                    paymentReady={taxReady}
                    total={taxReady ? tax.totalAmount : undefined}
                    currency={tax?.currency} 
                    setBillingFields={setBillingFields} 
                    billingFields={billingFields}
                  />
                </Elements> 
              </CheckoutPaymentDetails>
            :null}
          </CheckoutGrid>
        </PageAlwaysVisible>
      </OnePageCheckout>
  )
}
